import { 
  LayoutDashboard, 
  Package, 
  Users, 
  Building2, 
  ShoppingCart, 
  FileText, 
  Settings, 
  User,
  Factory,
  ClipboardList,
  BarChart3,
  Truck,
  Shield,
  Package2,
  Store,
  Warehouse,
  Receipt,
  IndianRupee,
  BarChart2,
  TrendingUp,
  Search,
  Hash,
  Box
} from 'lucide-react';

export enum ViewType {
  dashboard = 'dashboard',
  rmDashboard = 'rmDashboard',
  materialPlanning = 'materialPlanning',
  purchaseDashboard = 'purchaseDashboard',
  salesDashboard = 'salesDashboard',
  finishedGoodsDashboard = 'finishedGoodsDashboard',
  endgoodListing = 'endgoodListing',
  rawItemInformation = 'rawItemInformation',
  rawItemListing = 'rawItemListing',
  customerInformation = 'customerInformation',
  customerListing = 'customerListing',
  supplierInformation = 'supplierInformation',
  supplierListing = 'supplierListing',
  purchaseOrderListing = 'purchaseOrderListing',
  challanListing = 'challanListing',
  salesOrderListing = 'salesOrderListing',
  productionPlanning = 'productionPlanning',
  bomListing = 'bomListing',
  wipTracking = 'wipTracking',
  grnListing = 'grnListing',
  rawMaterialReceipt = 'rawMaterialReceipt',
  userProfile = 'userProfile',
  userListing = 'userListing',
  roleListing = 'roleListing',
  workOrderListing = 'workOrderListing',
  packingEntries = 'packingEntries',
  boxMaster = 'boxMaster',
  storeMaster = 'storeMaster',
  storeInventory = 'storeInventory',
  workerListing = 'workerListing',
  physicalMachineListing = 'physicalMachineListing',
  hsnListing = 'hsnListing',
  invoiceListing = 'invoiceListing',
  invoiceSalesReport = 'invoiceSalesReport',
  creditDebitReport = 'creditDebitReport',
  hsnReport = 'hsnReport',
  creditDebitNoteListing = 'creditDebitNoteListing',
  chargeMasterListing = 'chargeMasterListing',
  endgoodCostListing = 'endgoodCostListing',
  reports = 'reports',
  tracking = 'tracking',
}

export interface MenuItem {
  id: ViewType;
  label: string;
  path: string;
  icon: React.ComponentType<{ className?: string }>;
  category: string;
}

export const menuItems: MenuItem[] = [
  // Dashboard
  {
    id: ViewType.dashboard,
    label: 'Dashboard',
    path: '/dashboard',
    icon: LayoutDashboard,
    category: 'dashboard'
  },
  {
    id: ViewType.rmDashboard,
    label: 'RM Inventory Dashboard',
    path: '/dashboard/rm-inventory',
    icon: Warehouse,
    category: 'dashboard'
  },
  {
    id: ViewType.materialPlanning,
    label: 'Material Planning',
    path: '/dashboard/material-planning',
    icon: TrendingUp,
    category: 'dashboard'
  },
  {
    id: ViewType.purchaseDashboard,
    label: 'Purchase Dashboard',
    path: '/dashboard/purchase-dashboard',
    icon: ShoppingCart,
    category: 'dashboard'
  },
  {
    id: ViewType.salesDashboard,
    label: 'Sales Dashboard',
    path: '/dashboard/sales-dashboard',
    icon: BarChart2,
    category: 'dashboard'
  },
  {
    id: ViewType.finishedGoodsDashboard,
    label: 'Finished Goods',
    path: '/dashboard/finished-goods',
    icon: Package2,
    category: 'dashboard'
  },
  
  // Master Data
  {
    id: ViewType.endgoodListing,
    label: 'Endgood Listing',
    path: '/endgoods',
    icon: Package,
    category: 'master'
  },
  {
    id: ViewType.physicalMachineListing,
    label: 'Physical Machine Listing',
    path: '/physical-machines',
    icon: Factory,
    category: 'master'
  },
  {
    id: ViewType.hsnListing,
    label: 'HSN Master',
    path: '/hsn',
    icon: FileText,
    category: 'master'
  },
  {
    id: ViewType.rawItemListing,
    label: 'Raw Item Listing',
    path: '/raw-items',
    icon: Package,
    category: 'master'
  },
  // {
  //   id: ViewType.customerInformation,
  //   label: 'Customer Information',
  //   path: '/customers/new',
  //   icon: Users,
  //   category: 'master'
  // },
  {
    id: ViewType.workerListing,
    label: 'Worker Listing',
    path: '/workers',
    icon: Users,
    category: 'master'
  },
  {
    id: ViewType.customerListing,
    label: 'Customer Listing',
    path: '/customers',
    icon: Users,
    category: 'master'
  },
  // {
  //   id: ViewType.supplierInformation,
  //   label: 'Supplier Information',
  //   path: '/suppliers/new',
  //   icon: Building2,
  //   category: 'master'
  // },
  {
    id: ViewType.supplierListing,
    label: 'Supplier Listing',
    path: '/suppliers',
    icon: Building2,
    category: 'master'
  },
  
  // Sales & Orders
  {
    id: ViewType.purchaseOrderListing,
    label: 'Purchase Order Listing',
    path: '/purchase-orders',
    icon: ShoppingCart,
    category: 'sales'
  },
  {
    id: ViewType.salesOrderListing,
    label: 'Sales Order Listing',
    path: '/sales-orders',
    icon: FileText,
    category: 'sales'
  },
  
  // Production
  // {
  //   id: ViewType.productionPlanning,
  //   label: 'Production Planning',
  //   path: '/production-planning',
  //   icon: Factory,
  //   category: 'production'
  // },
  {
    id: ViewType.bomListing,
    label: 'BOM Listing',
    path: '/bom',
    icon: ClipboardList,
    category: 'production'
  },
  {
    id: ViewType.wipTracking,
    label: 'WIP Tracking',
    path: '/wip-tracking',
    icon: BarChart3,
    category: 'production'
  },
  {
    id: ViewType.grnListing,
    label: 'GRN Listing',
    path: '/grn',
    icon: Truck,
    category: 'sales'
  },
  {
    id: ViewType.rawMaterialReceipt,
    label: 'Manual GRN Entry',
    path: '/raw-material-receipt',
    icon: Package,
    category: 'sales'
  },
  {
    id: ViewType.workOrderListing,
    label: 'Work Orders',
    path: '/work-orders',
    icon: ClipboardList,
    category: 'production'
  },
  
  // Packing
  {
    id: ViewType.packingEntries,
    label: 'Packing Entries',
    path: '/packing-entries',
    icon: Package2,
    category: 'packing'
  },
  {
    id: ViewType.boxMaster,
    label: 'Box Master',
    path: '/packing-entries/box-master',
    icon: Box,
    category: 'packing'
  },
  
  // Tracking
  {
    id: ViewType.tracking,
    label: 'Tracking',
    path: '/tracking',
    icon: Search,
    category: 'production'
  },
  
  // Store Management
  {
    id: ViewType.storeMaster,
    label: 'Store Master',
    path: '/stores',
    icon: Store,
    category: 'store'
  },
  {
    id: ViewType.storeInventory,
    label: 'Store Inventory',
    path: '/store-inventory',
    icon: Warehouse,
    category: 'store'
  },
  // Invoice Management
  {
    id: ViewType.invoiceListing,
    label: 'Invoice Listing',
    path: '/invoices',
    icon: Receipt,
    category: 'invoice'
  },
  {
    id: ViewType.invoiceSalesReport,
    label: 'Sales Report',
    path: '/invoices/sales-report',
    icon: BarChart3,
    category: 'invoice'
  },
  {
    id: ViewType.creditDebitReport,
    label: 'Credit / Debit Report',
    path: '/invoices/credit-debit-report',
    icon: BarChart3,
    category: 'invoice'
  },
  {
    id: ViewType.hsnReport,
    label: 'HSN Report',
    path: '/invoices/hsn-report',
    icon: Hash,
    category: 'invoice'
  },
  {
    id: ViewType.creditDebitNoteListing,
    label: 'Credit / Debit Notes',
    path: '/invoices/credit-debit-notes',
    icon: IndianRupee,
    category: 'invoice'
  },
  {
    id: ViewType.chargeMasterListing,
    label: 'Charge Master',
    path: '/charge-masters',
    icon: Receipt,
    category: 'invoice'
  },
  {
    id: ViewType.endgoodCostListing,
    label: 'Endgood Cost',
    path: '/invoices/endgood-cost',
    icon: Package,
    category: 'invoice'
  },
  
  // CHALLAN
  {
    id: ViewType.challanListing,
    label: 'Challan Listing',
    path: '/challans',
    icon: Truck,
    category: 'challan'
  },
  
  // Reports
  {
    id: ViewType.reports,
    label: 'Reports',
    path: '/reports',
    icon: BarChart2,
    category: 'reports'
  },
  
  // System Administration
  {
    id: ViewType.userListing,
    label: 'User Management',
    path: '/users',
    icon: Users,
    category: 'admin'
  },
  {
    id: ViewType.roleListing,
    label: 'Role Management',
    path: '/roles',
    icon: Shield,
    category: 'admin'
  }
];

// export const branches = [
//   { id: "main", name: "Main Branch - Mumbai" },
//   { id: "branch2", name: "Branch 2 - Delhi" },
//   { id: "branch3", name: "Branch 3 - Bangalore" },
//   { id: "branch4", name: "Branch 4 - Chennai" }
// ];